import { AbstractDTO } from './abstract';
import { IAcl } from "@signature-it/ngx-generic/interfaces";
import { AclDTO } from "./acl";

export class CustomerDTO extends AbstractDTO {
    customer_id: number;
    name: string;
    phone: string;
    org_id: number;
    org_ou: number;
    is_supplier: number;
    acl: IAcl[];

    constructor(attributes?: object) {
        super(attributes);
        attributes = attributes ? attributes : {};

        this.customer_id = Number(attributes['customer_id']) || -1;
        this.name = attributes['name'] || "";
        this.phone = attributes['phone'] || "";
        this.org_id = Number(attributes['org_id']) || 0;
        this.org_ou = Number(attributes['org_ou']) || 0;
        this.is_supplier = Number(attributes['is_supplier']) || 0;
        this.acl = AclDTO.createFromArray(attributes['acl'] || []);
    }

}
